export const diagnosesFrag = `
    id
    code
    title
`;
